export default function DateFilterPanel({
  dates,
  setDates,
  handleDateApply,
  handleDateClear,
}) {
  return (
    <div className="container-fluid" id="filterPanelContainer">
      <div className="row">
        <div className="col-6 mt-4 ms-3">
          <div className="filterPanel d-flex align-items-center gap-3">
            <label>From Date:</label>
            <input
              type="date"
              value={dates?.from}
              onChange={(e) => setDates({ ...dates, from: e.target.value })}
            />

            <label>To Date:</label>
            <input
              type="date"
              value={dates?.to}
              onChange={(e) => setDates({ ...dates, to: e.target.value })}
            />

            <button className="btn btn-secondary" onClick={handleDateApply}>
              Apply
            </button>

            <button className="btn btn-secondary" onClick={handleDateClear}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
